import React, { useState } from "react";
import { SiHubspot } from "react-icons/si";
import { ClassNames, getCookie } from "../../../../../helper";
import AuthModal from "./AuthModal";
import { HubspotInstallGuide } from "../constants";
import Lists from "./Lists";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../../common/authenticateDashboard/authSlice";
import { updateDataInMongoDb } from "../../../../../services/mongod.data";

const ConnectWithHubspot = ({
  installHandler,
  integration,
  authName,
  setAuthName,
  page,
  setPage,
  lists,
  listId,
  setListId,
}) => {
  const [validAuth, setValidAuth] = useState(false);
  const [open, setOpen] = useState(false);
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const [loading, setLoading] = useState(false);

  const handleFinish = async () => {
    setLoading(true);
    await updateDataInMongoDb(user, "graph-integration", ["hubspot"], { listId: listId });
    installHandler(false);
    setPage(1);
    setLoading(false);
  };

  return (
    <div className="my-6 text-gray-500 relative">
      {open ? (
        <div className="relative">
          <AuthModal
            setOpen={setOpen}
            authName={authName}
            setAuthName={setAuthName}
          />
        </div>
      ) : null}

      <div className="p-4">
        {page === 1 ? (
          <div>
            <div className="text-center mx-auto mb-4">
              Integrate CausalFunnel with your HubSpot account. The integration
              allows you to:
              <ul className="text-sm mt-2 text-gray-700">
                <li>Create and update contacts in HubSpot</li>
                <li>Send chat transcripts to HubSpot</li>
              </ul>
            </div>
            <div className="">
              <h3 className="text-lg font-semibold text-center my-3">
                Connect with HubSpot account
              </h3>
              <div>
                <p>The only thing you need is the active HubSpot account</p>
                <ol className="list-decimal list-inside">
                  {HubspotInstallGuide?.map((item, index) => (
                    <li key={index}>{item.content}</li>
                  ))}
                </ol>
                {integration ? (
                  <div className="border-2 p-4 my-3.5">
                    <div className="border-2 border-green-500 p-2.5 flex gap-2 items-center hover:cursor-pointer hover:bg-white hover:shadow-sm">
                      <SiHubspot className="text-lg text-gray-800" />
                      <div>
                        <p className="text-xs text-gray-400">
                          HubSpot Connected
                        </p>
                        <p className="text-gray-700">{authName}</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    className="border-2 p-4 my-3.5"
                    onClick={() => setOpen(true)}
                  >
                    <div className="border-2 p-2.5 flex gap-1 items-center hover:cursor-pointer hover:bg-white hover:shadow-sm">
                      <SiHubspot className="text-lg text-gray-800" />
                      <p className="text-gray-700">New Authentication</p>
                    </div>
                  </div>
                )}
                <p>
                  We also described integration step by step in our{" "}
                  <a
                    href="https://www.causalfunnel.com/blog"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="text-indigo-600 hover:underline "
                  >
                    Knowledge base.
                  </a>
                </p>
              </div>
            </div>
          </div>
        ) : (
          <Lists lists={lists} listId={listId} setListId={setListId} />
        )}

        <hr className="my-3" />
        <div className="flex justify-between items-center">
          <div className="flex gap-x-2">
            <div
              className={`w-2 h-2 rounded-full ${
                page === 1 ? "bg-indigo-500" : "bg-gray-300"
              } cursor-pointer`}
            ></div>
            <div
              className={`w-2 h-2 rounded-full ${
                page === 2 ? "bg-indigo-500" : "bg-gray-300"
              } cursor-pointer`}
            ></div>
          </div>
          <div className="flex gap-x-4">
            {page === 1 ? (
              <button
                className="text-gray-800 hover:text-indigo-600"
                onClick={() => installHandler(false)}
              >
                Cancel
              </button>
            ) : (
              <button
                onClick={() => setPage(page - 1)}
                className="text-gray-800 hover:text-indigo-600"
              >
                Previous
              </button>
            )}
            {page === 1 ? (
              <button
                onClick={() => setPage(page + 1)}
                disabled={!integration}
                className={ClassNames(
                  "px-6 py-2 rounded-md",
                  integration
                    ? "text-white bg-indigo-600"
                    : "disabled bg-gray-200 text-gray-500 cursor-auto"
                )}
              >
                Next
              </button>
            ) : (
              <button
                onClick={handleFinish}
                className="px-6 py-2 rounded-md text-white bg-indigo-600"
              >
                {loading ? "Loading..." : "Finish"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConnectWithHubspot;
